import React from 'react'
import { isArray, isPlainObject } from 'lodash-es'
import { photoBgColor } from '@ow/utils'

const renderUserInfo = function (origin, defs) {
  const { findDataSlug } = defs || {}

  return (
    // FIXME: key 可能会重复
    <div className="flex items-center gap-2" key={origin.id}>
      {origin.photo ? (
        <img
          className="rounded-full"
          alt=""
          src={origin.photo}
          style={{ width: '24px', height: '24px', border: '1px solid #E7E7E7' }}
        />
      ) : (
        <div
          className="rounded-full text-white flex justify-center items-center"
          style={{
            background: photoBgColor(origin.id),
            width: '24px',
            height: '24px',
            border: '1px solid #fff',
          }}
        >
          {findDataSlug
            ? origin[findDataSlug]
              ? origin[findDataSlug][origin[findDataSlug].length - 1]
              : ''
            : origin.name
            ? origin.name[origin.name.length - 1]
            : ''}
        </div>
      )}

      {findDataSlug ? origin[findDataSlug] : origin.name}
    </div>
  )
}

const User = function ({ value, defs }) {
  if (isPlainObject(value)) {
    return renderUserInfo(value, defs)
  }

  if (isArray(value)) {
    return (
      <div className="w-full flex gap-2">
        {value.map((val) => {
          return renderUserInfo(val, defs)
        })}
      </div>
    )
  }

  return value
}

export default User
